import { useReactToPrint } from 'react-to-print';
import React, { useCallback } from 'react';
import { Button } from 'antd';

const formatDate = (date) => date.toISOString().split('T')[0];

export const pdfFooterLinks = [
  {
    label: "Go To Platform",
    link: "https://app.pivony.com/"
  },
  {
    label: "Watch Learning Center Videos",
    link: "https://learning.pivony.com/"
  },
  {
    label: "Read Tutorials",
    link: "https://www.pivony.com/tutorials"
  }
]

export const GetStaticPage = ({ dateObj, logo, coverText, coverSubtitle, links }) => {
  let coverDateString = dateObj;

  if(dateObj && dateObj === 'last7d'){
    const untilDate = new Date();
    const sinceDate = new Date();
    sinceDate.setDate(untilDate.getDate() - 7);

    coverDateString = `${formatDate(sinceDate)} to ${formatDate(untilDate)}`;
  }else {
    if(!dateObj){
      coverDateString = coverSubtitle
    }else coverDateString = `${dateObj.since} to ${dateObj.until}`
  }
  return (
		<div className="print-only print-cover-footer-page">
			<img src={logo || ""} alt="Logo" style={{ maxWidth: 200, marginBottom: 60 }} />
			<h1 className="cover-text mckinsey-title">
				{coverText || "Welcome"}
			</h1>
			<p className="mckinsey-subtitle">{coverDateString}</p>
			{links && links?.length && (
				<div className="printable-footer-btn-wrapper">
					{links?.map((link, index) => (
						<Button key={index} size="small" type="primary" className="printable-footer-btn mckinsey-cta">
							<a href={link.link}>{link.label}</a>
						</Button>
					))}
				</div>
			)}
		</div>
  );
};

export const useExportPDF = (contentRef, options = {}) => {
  const {
    documentTitle = `Dashboard-Report-${new Date().toISOString().split('T')[0]}`,
    pageSize = 'A4',
    margin = '15mm',
    onBeforeExport,
    onAfterExport,
  } = options;

  const handlePrint = useReactToPrint({
    // Try different approaches based on react-to-print version
    contentRef: contentRef,
    content: () => contentRef?.current,
    documentTitle,
    pageStyle: `
      @import url('https://fonts.googleapis.com/css2?family=Helvetica+Neue:wght@300;400;500;700&family=Inter:wght@300;400;500;600;700&display=swap');
      
      @page {
        size: ${pageSize};
        margin: ${margin};
      }
      @media screen {
        .print-only {
          display: none !important;
        }
      }
      @media print {
        body {
          -webkit-print-color-adjust: exact;
          color-adjust: exact;
          font-family: 'Inter', 'Helvetica Neue', -apple-system, BlinkMacSystemFont, sans-serif;
          color: $font-color;
        }
        
        .print-only {
          display: flex !important;
        }
        .print-cover-footer-page {
          display: flex !important;
          flex-direction: column;
          align-items: flex-start;
          justify-content: flex-start;
          height: 100vh;
          page-break-before: always;
          page-break-after: always;
          background: #E8E0F4 !important;
          padding: 80px 60px;
          box-sizing: border-box;
        }
        
        /* McKinsey Professional Title */
        .mckinsey-title {
          font-family: 'Inter', sans-serif !important;
          font-size: 36px !important;
          font-weight: 300 !important;
          line-height: 1.1 !important;
          color: #000000 !important;
          margin: 0 0 16px 0 !important;
          text-align: left !important;
          max-width: 70%;
        }
        
        .mckinsey-title strong,
        .mckinsey-title b {
          font-weight: 700 !important;
          color: #ef0055 !important;
        }
        
        /* McKinsey Professional Subtitle */
        .mckinsey-subtitle {
          font-family: 'Inter', sans-serif !important;
          font-size: 14px !important;
          font-weight: 400 !important;
          color: #666666 !important;
          margin: 0 0 60px 0 !important;
          text-align: left !important;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        
        /* McKinsey Professional CTA */
        .mckinsey-cta {
          font-family: 'Inter', sans-serif !important;
          font-size: 12px !important;
          font-weight: 500 !important;
          padding: 8px 16px !important;
          background: #000000 !important;
          border: none !important;
          border-radius: 0 !important;
          color: white !important;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        
        .mckinsey-cta a {
          color: white !important;
          text-decoration: none !important;
          font-weight: 600 !important;
        }
        
        /* Hide elements that shouldn't be printed */
        .no-print {
          display: none !important;
        }
        
        /* Show only in print */
        .print-only {
          display: block !important;
        }
        .date-label-print{
          background: #E8E0F4 !important;
          color: #000 !important;
        }
        .chart-container,
        .widget-container,
        .recharts-wrapper,
        .ant-card,
        .widget-item {
          page-break-inside: avoid !important;
          break-inside: avoid !important;
          margin-bottom: 20px;
        }
        
        .group-container, .printable-dashboard-header, .printable-content{
          background: #E8E0F4 !important;
        }
        
        /* Handle Draggable components in print */
        [data-rbd-draggable-id],
        [data-rbd-droppable-id] {
          page-break-inside: avoid !important;
          break-inside: avoid !important;
        }
        
        /* Widget card styling for your existing styles */
        .printable-widget-item {
          page-break-inside: avoid !important;
          break-inside: avoid !important;
          margin-bottom: 20px;
          padding: 15px;
          background: #FFFFFF !important;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
          color: #000 !important;
          /* Remove background override to preserve original widget colors */
        }

        .ant-table-wrapper{
          background-color: transparent !important;
          color: #000 !important;
          th{
            color: #000 !important;
          }
          td{
            color: #000 !important;
          }
        }
        
        /* McKinsey Professional Headings */
        h1, h2, h3, h4, h5 {
          font-family: 'Inter', sans-serif !important;
          font-weight: 500 !important;
          line-height: 1.2 !important;
          color: #000000 !important;
          margin-bottom: 12px !important;
        }
        
        h1 {
          font-size: 28px !important;
          font-weight: 300 !important;
        }
        
        h2 {
          font-size: 22px !important;
          font-weight: 500 !important;
        }
        
        h3 {
          font-size: 18px !important;
          font-weight: 500 !important;
        }
        
        h4 {
          font-size: 16px !important;
          font-weight: 500 !important;
        }
        
        h5 {
          font-size: 14px !important;
          font-weight: 500 !important;
        }
        
        .competitiveWidget {
          border-left: 4px solid #ff6b6b !important;
        }
        
        /* Force page breaks between major sections */
        .group-break {
          page-break-before: always;
        }
        
        /* Ensure content has proper print styling */
        .print-content {
          background-color: white !important;
        }
        
        .print-content * {
          background-color: transparent !important;
        }
        
        /* Force transparent backgrounds on all elements within print content */
        .print-content *:not(.preserve-bg) {
          background: transparent !important;
        }
        
        /* If you need to preserve specific backgrounds, add this class */
        .preserve-bg {
          /* Will keep original background */
        }
        
        /* Dashboard header styling with McKinsey typography */
        .dashboard-header {
          border-bottom: 2px solid #333;
          padding-bottom: 15px;
          margin-bottom: 25px;
          page-break-inside: avoid;
        }
        
        .time-indicator {
          font-family: 'Source Sans Pro', sans-serif !important;
          font-weight: 600 !important;
          font-size: 14px !important;
          text-transform: uppercase !important;
          letter-spacing: 0.05em !important;
        }
        
        /* Group widget styling */
        .group-widget {
          page-break-inside: avoid;
          margin-bottom: 30px;
          padding: 20px;
          border-radius: 8px;
        }
        
        .group-header {
          border-bottom: 1px solid #eee;
          padding-bottom: 12px;
          margin-bottom: 20px;
          page-break-inside: avoid;
        }
        
        .group-title {
          font-family: 'Source Sans Pro', sans-serif !important;
          font-size: 18px !important;
          font-weight: 600 !important;
          margin: 0 !important;
          letter-spacing: -0.01em !important;
        }
        
        /* Widget styling */
        .widget-item {
          page-break-inside: avoid;
          break-inside: avoid;
          margin-bottom: 20px;
          padding: 15px;
          border-radius: 6px;
        }
        
        .widget-title {
          font-family: 'Source Sans Pro', sans-serif !important;
          font-size: 16px !important;
          font-weight: 600 !important;
          margin-bottom: 15px !important;
          letter-spacing: -0.01em !important;
        }
        
        /* Force all widget containers to be transparent */
        .widget-container,
        .widget-content,
        .widget-body {
          background-color: transparent !important;
        }
        
        /* Chart specific styling */
        .recharts-cartesian-grid-horizontal line,
        .recharts-cartesian-grid-vertical line {
        }
        
        .recharts-text {
        }
        
        /* Force chart containers to preserve original colors */
        .recharts-wrapper,
        .recharts-surface,
        .recharts-layer,
        .chart-container {
        }
        
        /* Remove any default grey backgrounds from chart elements */
        .recharts-default-tooltip,
        .recharts-tooltip-wrapper,
        .recharts-legend-wrapper {
        }
        
        /* Table styling if you have tables */
        .ant-table,
        table {
          border-collapse: collapse;
          width: 100%;
          margin-bottom: 15px;
        }
        
        .ant-table th,
        .ant-table td,
        th, td {
          padding: 8px;
          text-align: left;
        }
        
        .ant-table th,
        th {
          font-weight: bold;
        }
        
        /* Remove Ant Design default backgrounds */
        .ant-table-container,
        .ant-table-content,
        .ant-table-body,
        .ant-table-thead > tr > th,
        .ant-table-tbody > tr > td {
          background-color: transparent !important;
        }
        
        .cover-text{
          color: #ef0055 !important;
        }
        
        .highest-score-box{
          color: #000 !important;
          background: #E8E0F4 !important;
          svg{
            fill: #000 !important;
          }
        }
        
        .printable-footer-btn-wrapper{
          margin-top: 30px;
          display: flex;
          gap: 16px;
          justify-content: flex-start;
        }
        
        .printable-footer-btn{
          padding: 12px 24px !important;
          background: #4400aa !important;
          color: white !important;
          font-size: 14px !important;
          border-radius: 4px !important;
          border: none !important;
          font-weight: 500 !important;
        }
        
        .printable-footer-btn a{
          text-decoration: none !important;
          color: white !important;
          font-weight: 600 !important;
        }
        
        .printable-gauge-indicator{
          color: #FFFFFF !important;
        }
        
        /* Professional body text styling */
        body, p, span, div {
          font-family: 'Source Sans Pro', sans-serif !important;
          font-size: 14px !important;
          line-height: 1.5 !important;
          color: #333333 !important;
        }
      }
    `,
    onBeforeGetContent: async () => {
      // Check if content exists before proceeding
      if (!contentRef?.current) {
        console.error('Content ref is not available for export');
        throw new Error('Content not available');
      }
      
      if (!contentRef.current.innerHTML || contentRef.current.innerHTML.trim() === '') {
        console.error('Content is empty');
        throw new Error('Content is empty');
      }
      
      if (onBeforeExport) {
        await onBeforeExport();
      }
    },
    onAfterPrint: () => {
      console.log('Dashboard PDF export completed successfully!');
      if (onAfterExport) {
        onAfterExport();
      }
    },
    onPrintError: (errorLocation, error) => {
      console.error('Print error at:', errorLocation, 'Error:', error);
      if (onAfterExport) {
        onAfterExport(`Print error: ${error}`);
      }
    },
  });

  // Return a wrapped function that adds additional safety checks
  return useCallback(async () => {
    if (!contentRef?.current) {
      console.error('Export failed: Content reference is not available');
      if (onAfterExport) {
        onAfterExport('Export failed: Content not available');
      }
      return;
    }

    if (!contentRef.current.innerHTML || contentRef.current.innerHTML.trim() === '') {
      console.error('Export failed: Content is empty');
      console.error('Content HTML:', contentRef.current.innerHTML);
      if (onAfterExport) {
        onAfterExport('Export failed: Content is empty');
      }
      return;
    }

    // Add a small delay to ensure content is fully rendered
    await new Promise(resolve => setTimeout(resolve, 100));

    console.log('Starting export with content element:', contentRef.current);
    console.log('Content preview:', contentRef.current.innerHTML.substring(0, 200) + '...');
    
    handlePrint();
  }, [handlePrint, contentRef, onAfterExport]);
};

export default useExportPDF;